import React from 'react'

export default props => 
    <a className="px-4 py-2 m-auto my-12 rounded-lg text-center 
    text-white bg-red-700 hover:bg-gray-700">
        {props.children}
    </a>
